import { EVENT_SOUND_IDS } from "./soundRegistry.ts";
import type { GameAudioTrigger, SoundId } from "./types.ts";

export function resolveSoundTrigger(trigger: GameAudioTrigger): SoundId | null {
  switch (trigger.type) {
    case "outcome":
      return trigger.kind === "victory" ? "victory" : "defeat";
    case "tileEntered":
      return "tileEnter";
    case "randomEventStarted":
      return EVENT_SOUND_IDS[trigger.eventId] ?? null;
  }
}
